import $ from 'jquery'

class JobFilter {
    constructor() {
        $('#filter-toggle').on("click", () => {
            $("#filter-toggle").each((index, item) => {
                if (item.innerText === "Alle Stellen") {
                    item.innerText = "Stellen in der Schweiz"
                    this.withCH()
                    this.withoutDE()
                } else if (item.innerText === "Stellen in der Schweiz") {
                    item.innerText = "Stellen in Deutschland"
                    this.withDE()
                    this.withoutCH()
                } else {
                    item.innerText = "Alle Stellen"
                    this.withCH()
                    this.withDE()
                }
            })
        })
    }

    withoutCH() {
        $(".ch").each((index, item) => {
            item.style.display = 'none'
        })
    }
    withoutDE() {
        $(".de").each((index, item) => {
            item.style.display = 'none'
        })
    }
    withCH() {
        $(".ch").each((index, item) => {
            item.style.display = 'flex'
        })
    }
    withDE() {
        $(".de").each((index, item) => {
            item.style.display = 'flex'
        })
    }

}

export default JobFilter
